// extracted by mini-css-extract-plugin
export var background = "bJ_x";
export var backgroundContainer = "bJ_fj";
export var bottomWave = "bJ_cT";
export var buttons = "bJ_cD";
export var container = "bJ_b";
export var content = "bJ_bx";
export var icon = "bJ_bv";
export var iconContainer = "bJ_cs";
export var middleWave = "bJ_cS";
export var negativeTop = "bJ_hc";
export var overlap = "bJ_hf";
export var section = "bJ_d";
export var selected = "bJ_bg";
export var tab = "bJ_dQ";
export var tabText = "bJ_dP";
export var title = "bJ_h";
export var topWave = "bJ_hd";